import ExecutiveBio from "../components/about/ExecutiveBio";
import Timeline from "../components/about/Timeline";
import VisionStatement from "../components/about/VisionStatement";

const About = () => {
  return (
    <div className="page-container">
      <ExecutiveBio />
      <Timeline />
      <VisionStatement />
    </div>
  );
};

export default About;